<div class="controls-container">
    <div class="controls-header">Grid</div>
    
    <pm-grid [style.height]="'600px'"
             [style.display]="'block'"
             [ItemsSource]="ItemsSource"
             [FrozenColumnCount]="1"
             [Columns]="Columns"
             [(SelectedRow)]="SelectedItem">
    </pm-grid>    
</div>




// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/grid/grid.html